import React from 'react'
import './styles.scss'

function FloorSwitcher({switchGround,switchFirst}){
    return(
        <div className="floor-switcher">
            <button className="switch-button-1 active" name="ground" id="ground" onClick={switchGround}>First Floor</button>
            <button className="switch-button-2" name="first" id="first" onClick={switchFirst}>Second Floor</button>
        </div>
    )
}

export default FloorSwitcher